import { checkCanUseWebP } from './checkCanUseWebP';

const canUseWebP = checkCanUseWebP();

export const getLargeThumbnailURLsOfPages = (thumbnailURL, type, numPages) => {
  let thumbnailURLs = [];
  if (thumbnailURL) {
    if (thumbnailURL.endsWith('/')) {
      let ext = 'webp';
      if (!canUseWebP) {
        if (type === 'element' || type === 'designer-elements') {
          ext = 'png';
        } else {
          ext = 'jpeg';
        }
      }
      const parts = thumbnailURL.split('/');
      for (let i = 0; i < numPages; i++) {
        thumbnailURLs.push(
          thumbnailURL + `${i + 1}/${parts[parts.length - 2]}-1500.${ext}`,
        );
      }
    } else {
      const prevUrl = thumbnailURL.substring(
        0,
        thumbnailURL.lastIndexOf('/') + 1,
      );
      const lastUrl = thumbnailURL.substring(thumbnailURL.lastIndexOf('/') + 1);
      for (let i = 0; i < numPages; i++) {
        thumbnailURLs.push(`${prevUrl}${i + 1}/${lastUrl}`);
      }
    }
  }
  return thumbnailURLs;
};
